import { render, staticRenderFns } from "./SoldBrokerDeals.vue?vue&type=template&id=77308daa"
import script from "./SoldBrokerDeals.vue?vue&type=script&lang=js"
export * from "./SoldBrokerDeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports